/* ── A Real Girl World — Theme JS ── */
document.addEventListener('DOMContentLoaded', function () {

  // ── Sticky Nav ──
  const nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // ── Scroll Reveal ──
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => observer.observe(el));
  }

  // ── Lookbook Drag Scroll ──
  const scroll = document.querySelector('.lookbook-scroll');
  if (scroll) {
    let isDown = false, startX, scrollLeft;
    scroll.addEventListener('mousedown', e => {
      isDown = true; scroll.style.cursor = 'grabbing';
      startX = e.pageX - scroll.offsetLeft; scrollLeft = scroll.scrollLeft;
    });
    scroll.addEventListener('mouseleave', () => { isDown = false; scroll.style.cursor = 'grab'; });
    scroll.addEventListener('mouseup', () => { isDown = false; scroll.style.cursor = 'grab'; });
    scroll.addEventListener('mousemove', e => {
      if (!isDown) return; e.preventDefault();
      scroll.scrollLeft = scrollLeft - (e.pageX - scroll.offsetLeft - startX) * 1.5;
    });
  }

  // ── Hero Scroll Indicator ──
  const heroScroll = document.querySelector('.hero-scroll-indicator');
  if (heroScroll) {
    heroScroll.addEventListener('click', () => {
      const target = document.querySelector('.collections-section') || document.querySelector('main section:nth-child(2)');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  // ── Cart Icon Count ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const countEl = document.querySelector('.cart-item-count');
        if (countEl) countEl.textContent = cart.item_count;
        const badge = document.querySelector('.cart-count');
        if (badge) badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
  }
  updateCartCount();

  // ── Add to Cart ──
  const atcForm = document.querySelector('.product-add-to-cart-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = this.querySelector('.add-to-cart');
      btn.textContent = 'Adding...';
      const formData = new FormData(this);
      const data = {};
      formData.forEach((v, k) => data[k] = v);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added!';
        updateCartCount();
        setTimeout(() => btn.textContent = 'Add to Cart', 2000);
      })
      .catch(() => { btn.textContent = 'Add to Cart'; });
    });
  }

  // ── Cart Quantity Update ──
  document.querySelectorAll('[data-quantity-input]').forEach(input => {
    input.addEventListener('change', function () {
      const line = this.closest('.cart-line');
      const index = line ? line.dataset.line : null;
      if (!index) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(index, 10), quantity: parseInt(this.value, 10) })
      })
      .then(r => r.json())
      .then(() => { updateCartCount(); window.location.reload(); });
    });
  });

});
